const items = {
	"blog.overview": "概览",
	"blog.palicanon": "译文",
};

export default items;
